<template>
  <div class="animated fadeIn">
    <div id="snackbar"></div>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong> Static Pages</strong>
            <small>Form</small>
          </div>
          <b-form v-on:submit.prevent.self="submitFinalData">
            <b-row>
              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <multiselect
                    v-model="pagesList.main_name"
                    :disabled="$route.query.mpm_id ? true : false"
                    :options="pageList"
                    :multiple="false"
                    placeholder="Select Page"
                  ></multiselect>
                  <!-- <b-form-input
                    type="text"
                    required
                    v-model="staticBanner.pagename"
                    id="bannerURL"
                    placeholder="Page Name"
                  ></b-form-input> -->
                </b-form-group>
              </div>
              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <!-- <label for="country">Language <span class="text-danger">*</span></label> -->
                  <!-- <b-form-input type="text" v-model="cinema.Country" id="country" placeholder="Country"></b-form-input> -->
                  <multiselect
                    :options="LanguageArray"
                    :disabled="$route.query.mpm_id ? true : false"
                    :multiple="false"
                    track-by="lang_id"
                    label="lang_name"
                    placeholder="Select Language"
                    @select="languageSelect"
                    v-model="selectedLang"
                  ></multiselect>
                  <!-- <b-form-select required  v-model="banner.LanguageID" id="month1"
                  :plain="true"
                  value-field="LanguageID"
                  text-field="LanguageName"
                  :options=LanguageArray>
                   <template slot="first">
                        <option :value="0" disabled>-- Select Language --</option>
                    </template>
                </b-form-select> -->
                </b-form-group>
              </div>

              <!-- <div class="col-lg-4 col-xl-3 align-self-center mb-4"></div> -->

              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <label for="logo">
                    Banners
                    <br />Size: 1520*500
                  </label>
                  <input
                    name="image_arr"
                    ref="fileinput"
                    v-on:change="uploadBanner($event.target)"
                    accept="image/jpeg, image/png, image/gif"
                    type="file"
                    multiple
                  />
                  <input type="hidden" v-model="pagesList.banner" />
                </b-form-group>
                <div
                  style="cursor: pointer"
                  @click="seeImagesFill('banner', -1)"
                  v-if="pagesList.banner"
                >
                  <u>See {{ pagesList.banner.split(",").length }} images</u>
                </div>
              </div>
              <b-form-checkbox
                v-model="pagesList.status"
                unchecked-value="N"
                value="Y"
                class="j-checkbox ml-3 mb-3"
              >
                Status
              </b-form-checkbox>
              <b-col sm="12" class="mt-3 mb-3">
                <h5>Other Data:</h5>
              </b-col>
            </b-row>

            <!-- DETAIL DATA PAGE -->

            <b-row
              class="m-2 "
              v-for="(item, index) in pagesList.otherData"
              :key="index"
            >
              <b-row
                v-if="item.o_status == 'Y'"
                style="padding: 5px;border: 1px solid #968888;             border-radius: 5px;
"
              >
                <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                  <b-form-group>
                    <div class="input-material mt-2">
                      <b-form-input
                        type="text"
                        v-model="item.main_name"
                        id="bannerURL"
                        placeholder="Main Name"
                      ></b-form-input>
                      <label>Main Name</label>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                  <b-form-group>
                    <div class="input-material mt-2">
                      <b-form-input
                        type="text"
                        v-model="item.header_name"
                        id="bannerURL"
                        placeholder="Sub Header"
                      ></b-form-input>
                      <label>Header Name</label>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                  <b-form-group>
                    <div class="input-material mt-2">
                      <b-form-input
                        type="text"
                        v-model="item.description"
                        id="bannerURL"
                        placeholder="Description"
                      ></b-form-input>
                      <label>Description</label>
                    </div>
                  </b-form-group>
                </div>
                <b-col sm="4">
                  <b-form-group>
                    <label for="logo">
                      Images
                      <br />Size: 174*309
                    </label>
                    <b-form-file
                      ref="fileinput"
                      v-on:change="
                        uploadImageHandler(
                          $event.target,
                          'images',
                          { w: 174, h: 309 },
                          index
                        )
                      "
                      accept="image/jpeg, image/png, image/gif"
                      :plain="true"
                      multiple
                    ></b-form-file>
                    <input type="hidden" v-model="item.images" />
                  </b-form-group>
                  <div
                    style="cursor: pointer"
                    @click="seeImagesFill('images', index)"
                    v-if="item.images"
                  >
                    <u
                      >See
                      {{ item.images.split && item.images.split(",").length }}
                      images</u
                    >
                  </div>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="logo">
                      Cover Image
                      <br />Size: 174*309
                    </label>
                    <b-form-file
                      ref="fileinput"
                      v-on:change="
                        uploadImageHandler(
                          $event.target,
                          'cover_image',
                          { w: 174, h: 309 },
                          index
                        )
                      "
                      accept="image/jpeg, image/png, image/gif"
                      :plain="true"
                    ></b-form-file>
                    <input type="hidden" v-model="item.cover_image" />
                  </b-form-group>
                  <div
                    style="cursor: pointer"
                    @click="seeImagesFill('cover_image', index)"
                    v-if="item.cover_image"
                  >
                    <u>See {{ item.cover_image.split(",").length }} images</u>
                  </div>
                </b-col>
                <b-col sm="1" style="margin-top:2%">
                  <i
                    v-if="index == 0"
                    style="margin-top: 1rem;"
                    class="fa fa-plus-square-o text-success mt-3 mx-2"
                    @click="addBannerFormat"
                  ></i>
                  <i
                    v-else
                    style="margin-top: -15px;"
                    class="fa fa-minus-square-o text-danger mx-2"
                    @click="removeBannerImage(index)"
                  ></i>
                </b-col>
              </b-row>
            </b-row>

            <b-row class="m-2">
              <b-col sm="4">
                <b-button type="submit" size="sm" variant="primary">
                  <i class="fa fa-dot-circle-o"></i>
                  {{ staticNames.name }}
                </b-button>
              </b-col>
              <b-col sm="4">
                <b-button
                  @click="resetStaticBanner"
                  size="sm"
                  variant="success"
                >
                  <i class="fa fa-dot-circle-o"></i> Reset
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <div>
      <b-modal
        id="modalPopover"
        title="See Images"
        ref="showImages"
        @ok="onOkay"
      >
        <div>
          <draggable
            v-model="bannerImg"
            class="d-flex justify-content-center flex-wrap"
            group="image"
            @start="drag = true"
            @end="drag = false"
          >
            <div
              sm="4"
              v-for="(item, index) in bannerImg"
              :key="index"
              class="m-2"
            >
              <img
                :src="_GetImagePath(item)"
                style="width:100px;height:100px"
              />
              <div class="m-2">
                <button class="btn-blue" @click="removeImagesFill(index)">
                  Remove
                </button>
              </div>
            </div>
          </draggable>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal
        id="redirectModal"
        ref="redirectModal"
        @ok="handleRedirect"
        title="Record Found"
        class="center-footer"
        footer-class="justify-content-center border-0"
        cancel-variant="outline-danger"
        ok-variant="outline-success"
        centered
        hide-header
        no-close-on-esc
        no-close-on-backdrop
      >
        <div class="d-block text-center">
          <div>
            Record with same name and language found. Edit from view list pages.
          </div>
        </div>
      </b-modal>
    </div>
    <b-modal
      id="ModalConfirmationOnSubmit"
      ref="ModalConfirmationOnSubmit"
      @ok="handleModalOkay"
      :title="modalObject.title"
      class="center-footer"
      footer-class="justify-content-center border-0"
      cancel-variant="outline-danger"
      ok-variant="outline-success"
      centered
      hide-header
      no-close-on-esc
      no-close-on-backdrop
    >
      <div class="d-block text-center">
        <div>{{ modalObject.message }}</div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import MovieService from "@/services/MovieService";
// import MasterService from "@/services/MasterService";
// import CinemaService from "@/services/CinemaService";
// import CommonService from "@/services/CommonService";
import draggable from "vuedraggable";
import MasterService from "@/services/MasterService";
import ExhibitorService from "@/services/ExhibitorService";
import { BASEURL, IMGBASEURL } from "@/config/index";
// import UploadService from "@/services/UploadService";

export default {
  name: "ListOfPages",
  data() {
    return {
      bannerType: "",
      bannerIndex: "",
      BaseURL: "",
      staticNames: {
        name: "Add"
      },
      modalObject: {
        title: "fdsfds"
      },
      cinemaListArray: [],
      LanguageArray: [],
      pagesList: {
        mpm_id: "",
        main_name: "",
        lang_id: 0,
        banner: "",
        status: "Y",
        otherData: [
          {
            mpm_d_id: "",
            main_name: "",
            header_name: "",
            description: "",
            images: "",
            cover_image: "",
            o_status: "Y"
          }
        ]
      },
      updateList: {
        mpm_id: "",
        main_name: "",
        lang_id: 0,
        banner: "",
        status: "Y",
        otherData: [
          {
            mpm_d_id: "",
            main_name: "",
            header_name: "",
            description: "",
            images: "",
            cover_image: "",
            o_status: "Y"
          }
        ]
      },
      staticBanner: {
        appthumbimage: "",
        selectedMovieBanner: [],
        desktopbanner: "",
        LanguageID: "",
        appbanner: "",
        youtube: "",
        BannerIsActive: true,
        Flag: 1,
        id: "",
        pagename: "",
        active: true,
        banners: "",
        otherdata: [
          {
            header: "",
            header1: "",
            description: "",
            images: "",
            coverimage: ""
          }
        ]
      },

      getBannerDetails: [],
      moviesList: [],
      SeeImages: [],
      pageList: [
        "premiere",
        "branches",
        "showTimes",
        "expe",
        "foodMenu",
        "cinemaOffer",
        "privateBooking",
        "bookEventBanner"
      ],
      imagesVmodel: "",
      imagesIndex: "",
      bannerImg: [],
      selectedLang: null,
      getAllPagesList: [],
      checkData: [],
      checkStatus: false,
      mpmId: null,
      IMGBASEURL: IMGBASEURL
      //       PageName: "premiere"
      //  PageName: "foodMenu"
      //  PageName: "branches"
      //  PageName: "showTimes"
      //  PageName: "expe"
      //  PageName: "foodMenu",
      //  PageName: "cinemaOffer",
    };
  },
  components: {
    // cSwitch,
    draggable
  },
  computed: {},
  watch: {},
  beforeMount() {
    const { movieId, mpm_id } = this.$route.query;

    if (mpm_id) {
      this.getLanguagesList().then(() => {
        this.getListOfPages();
      });

      // this.pagesList.id = page_id;

      // this.getBannersDetails(page_id);
      // this.banner.selectedMovieBanner = String(movieId);
      this.staticNames.name = "Update";
    } else {
      // this.getMoviesList();
      //  this.getCinemaListById()
      this.getLanguagesList();
    }
  },
  mounted: function() {
    this.getListOfPages();
    this.getLanguagesList();
  },
  methods: {
    handleRedirect() {
      console.log("redirect");
    },
    onOkay() {
      console.log("okay clicked");
      if (this.imagesIndex < 0) {
        this.pagesList[this.bannerType] = this.bannerImg.join(",");
      } else {
        this.pagesList.otherData[this.bannerIndex][
          this.bannerType
        ] = this.bannerImg.join(",");
      }
    },
    seeImagesFill(model_name, index) {
      this.imagesIndex = index;
      this.imagesVmodel = model_name;
      this.bannerType = model_name;
      this.bannerIndex = index;
      if (this.imagesIndex < 0) {
        this.bannerImg = this.pagesList[this.imagesVmodel].split(",");
      } else {
        this.bannerImg = this.pagesList.otherData[this.imagesIndex][
          this.imagesVmodel
        ].split(",");
      }
      console.log(this.bannerImg, "seeImages");
      this.$refs.showImages.show();
    },
    removeImagesFill(index) {
      this.bannerImg.splice(index, 1);

      if (this.imagesIndex < 0) {
        this.pagesList[this.imagesVmodel] = this.bannerImg.join(",");
      } else {
        this.pagesList.otherData[this.imagesIndex][
          this.imagesVmodel
        ] = this.bannerImg.join(",");
      }

      console.log(this.staticBanner[this.imagesVmodel], "fsddfsdfsdfsd");
      this.showMessageSnackbar("Image Removed Successfully");
      this.$refs.showImages.hide();
    },
    addBannerFormat() {
      let obj = {
        main_name: "",
        header_name: "",
        description: "",
        images: "",
        cover_image: "",
        o_status: "Y"
      };
      this.pagesList.otherData.push(obj);
    },
    removeBannerImage(index) {
      this.pagesList.otherData[index]["o_status"] = "N";
      // this.pagesList.otherData.splice(index, 1);
      console.log("this.pagesListNew", this.pagesList);
    },

    languageSelect: function(languageList) {
      // this.pagesList.lang_id = languageList.lang_id;
      if (this.pagesList.main_name) {
        this.checkData = this.getAllPagesList.filter(x => {
          return (
            x.mpm_name == this.pagesList.main_name &&
            x.mpm_lang_id == languageList.lang_id
          );
        });
        if (this.checkData.length > 0) {
          this.mpmId = this.checkData[0].mpm_id ? this.checkData[0].mpm_id : "";
          this.$bvModal.show("redirectModal");
          this.checkStatus = true;
        }
      } else {
        console.log("this.checkData from else", this.checkData);
      }
    },
    getLanguagesList: function() {
      // getCountriesList
      let payload = {
        tableName: "ms_language",
        lang_is_active: "Y"
      };
      return MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            console.log("langres", data.Records);
            this.LanguageArray = data.Records;
          } else {
            console.log("Error from language", data.message);
          }
        })
        .catch(error => {
          console.log(error, "from language catch");
        });
    },
    getCinemaListById: function() {
      let payload = {
        OrgID: 0
      };
      CinemaService.getCinemas(payload)
        .then(response => {
          const { data } = response;
          if (data && data.Status && data.CinemaList.length > 0) {
            console.log(data.CinemaList);
            this.cinemaListArray = data.CinemaList.filter(x => {
              return x.CinemaIsActive;
            });
            this.cinemaListArray.unshift({
              CinemaChargesID: null,
              CinemaID: "0",
              CinemaName: "All",
              ThumbnailImage: "0",
              Address: "HO",
              OrganizationID: "1",
              Phone: "HO",
              Email: "0",
              Location: "RIYADH",
              CountryID: "230",
              StateID: "0",
              DataProviderID: "0",
              DataProviderCinemaID: "0",
              CityID: "1",
              Pincode: "0",
              Latitude: "0",
              Longitude: "0",
              No_of_Schedules: "0",
              Booking_CutoffTime: "0",
              SCExpiry: "00",
              Booking_Max_No_Seats: "0",
              CinemaIsActive: false,
              Flag: 0,
              BaseURL: "https://apinew.empirecinemas.com/"
            });

            if (this.getBannerDetails.length > 0) {
              let cinemaIdArrayList = [];
              this.getBannerDetails[0].CinemaID.map(y => {
                let objNew = this.cinemaListArray.filter(x => {
                  return x.CinemaID == y;
                })[0];
                console.log(objNew, "fsdfsdf");
                cinemaIdArrayList.push(objNew);
              });
              this.staticBanner.CinemaIDArray = cinemaIdArrayList;
            }

            // let previewDiv = document.getElementById("preview");
            // while (previewDiv.firstChild) {
            //   previewDiv.removeChild(previewDiv.firstChild);
            // }
            // var previewImg = document.createElement("img");
            // previewDiv.appendChild(previewImg);
            // previewImg.src =
            //   data.CinemaList[0].BaseURL + data.CinemaList[0].ThumbnailImage;
            // previewImg.classList.add("img-fluid");

            // //
            // let previewDivHeaderImage = document.getElementById("HeaderImage");
            // while (previewDivHeaderImage.firstChild) {
            //   previewDivHeaderImage.removeChild(
            //     previewDivHeaderImage.firstChild
            //   );
            // }
            // var previewOne = document.createElement("img");
            // previewDivHeaderImage.appendChild(previewOne);
            // previewOne.src =
            //   data.CinemaList[0].BaseURL + data.CinemaList[0].ThumbnailImage;
            // previewOne.classList.add("img-fluid");

            // //
            // let previewDivHeaderWebImage = document.getElementById(
            //   "HeaderWebImage"
            // );
            // while (previewDivHeaderWebImage.firstChild) {
            //   previewDivHeaderWebImage.removeChild(
            //     previewDivHeaderWebImage.firstChild
            //   );
            // }
            // var previewTwo = document.createElement("img");
            // previewDivHeaderWebImage.appendChild(previewTwo);
            // previewTwo.src =
            //   data.CinemaList[0].BaseURL + data.CinemaList[0].ThumbnailImage;
            // previewTwo.classList.add("img-fluid");
          } else {
            this.showMessageSnackbar(data.Message);
          }
        })
        .catch(error => {
          this.showMessageSnackbar(
            "Oops! Something went wrong. kindly contact your administrator"
          );
        });
    },
    selectAllCinema: function(cinemaList) {
      if (cinemaList.CinemaName == "All") {
        setTimeout(x => {
          this.staticBanner.CinemaIDArray = this.cinemaListArray.filter(x => {
            return parseInt(x.CinemaID) > 0;
          });
        }, 100);
      }
    },
    getBannersDetails: function(pageid) {
      let payload = {
        pageid
      };

      MasterService.getPageViewById(payload)
        .then(response => {
          const { data } = response;
          if (data.Status) {
            this.BaseURL = data.BaseURL;
            // this.staticBanner.Flag = 2;
            // this.staticBanner.desktopbanner = data.BannerList[0].desktopbanner;
            // this.staticBanner.appbanner = data.BannerList[0].appbanner;
            // this.staticBanner.youtube = data.BannerList[0].youtube;
            // this.BaseURL = data.BaseURL;
            Object.keys(data.PageList).map(x => {
              console.log(x);
              if (this.staticBanner.hasOwnProperty(x)) {
                if (x == "banners") {
                  this.staticBanner[x] = data.PageList[x].join(",");
                } else if (x == "otherdata") {
                  data.PageList[x].map(z => {
                    z["images"] =
                      z["images"].length > 0 ? z["images"].join(",") : "";
                  });
                  console.log(data.PageList[x], "fsfsdfs33333df");
                  this.staticBanner["otherdata"] = data.PageList[x];
                } else {
                  this.staticBanner[x] = data.PageList[x];
                }
              }
            });

            this.getBannerDetails = [data.PageList];
            // this.getMoviesList();
            // this.getCinemaListById()
            this.getLanguagesList();
            // var previewDiv = document.getElementById("preview");
            // var previewImg = "";
            // var previewImg = document.createElement("img");
            // while (previewDiv.firstChild) {
            //   previewDiv.removeChild(previewDiv.firstChild);
            // }
            // previewDiv.appendChild(previewImg);
            // previewImg.src = data.BaseURL + data.BannerList[0].Image;
            // previewImg.classList.add("img-fluid");
          } else {
            this.showMessageSnackbar(data.Message);
          }
        })
        .catch(error => {
          console.log("Catch on Banner-getBannerByID Error: ", error);
          this.showMessageSnackbar(
            "Oops! Something went wrong. kindly contact your administrator"
          );
        });
    },
    submitStaticBanner: function() {
      if (!this.staticBanner.pagename) {
        this.showMessageSnackbar("Please Select Any Movie");
      } else if (!this.staticBanner.LanguageID) {
        this.showMessageSnackbar("Please Select Any Language");
      } else if (!this.staticBanner.banners) {
        this.showMessageSnackbar("Please Select Banner Image");
      } else {
        let payload = {
          title: "Confirmation",
          message: "Please re-check the data before submit"
        };
        this.showSubmitConfirmation(payload);
      }
    },
    // submitFinalData: function() {
    //   this.closeModal("ModalConfirmationOnSubmit");
    //   let payload = {
    //     ...this.staticBanner,

    //     languageid: this.staticBanner.LanguageID.hasOwnProperty("LanguageID")
    //       ? this.staticBanner.LanguageID.LanguageID
    //       : this.staticBanner.selectedMovieBanner
    //   };
    //   console.log(payload, this.SeeImages);
    //   // payload.banners  = this.SeeImages;
    //   payload.banners = payload["banners"].split(",");
    //   // payload.banners = this.SeeImages;
    //   payload.otherdata.map(x => {
    //     x["images"] = x["images"] ? x["images"].split(",") : "";
    //   });
    //   console.log(payload);
    //   // return

    //   MasterService.addPageData(payload)
    //     .then(response => {
    //       console.log("payoojasfo", payload);
    //       const { data } = response;
    //       data.Message ? this.showMessageSnackbar(data.Message) : "";

    //       if (data.Status) {
    //         // this.resetStaticBanner();
    //         // this.showMessageSnackbar("Added Updated Successfully");
    //         // var previewDiv = document.getElementById("preview");
    //         // var previewImg = "";
    //         // var previewImg = document.createElement("img");
    //         // while (previewDiv.firstChild) {
    //         //   previewDiv.removeChild(previewDiv.firstChild);
    //         // }
    //         this.$router.push({
    //           path: "/food-drink/list-pages"
    //         });
    //       }
    //     })
    //     .catch(error => {
    //       console.log("Catch on Banner-getBannerByID Error: ", error);
    //       this.showMessageSnackbar(
    //         "Oops! Something went wrong. kindly contact your administrator"
    //       );
    //     });
    // },

    uploadAppThumbBanner: function(image) {
      let refs = this.$refs;
      var self = this;
      var _URL = window.URL || window.webkitURL;
      var file, img;
      if ((file = image.files[0])) {
        img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = async function() {
          // if (img.height != 254 || img.width != 179) {
          //   // if (false) {
          //   self.$refs["fileinput"].reset();
          //   self.showMessageSnackbar("Please upload a 1520x500 image");
          // } else {
          var formdata = new FormData();
          formdata.append("assets/images/movies/banners", image.files[0]);
          UploadService.uploadFiles(formdata)
            .then(response => {
              response.data.Message
                ? self.showMessageSnackbar(response.data.Message)
                : "";

              if (response.data.Status) {
                self.staticBanner.appthumbimage = response.data.Path;
                self.BaseURL = response.data.BaseURL;
              }
            })
            .catch(error => {
              console.log("Catch on AddStaticImages-onUpload Error: ", error);
              self.showMessageSnackbar(
                "Oops! Something went wrong. kindly contact your administrator"
              );
            });
          // }
        };
      }
    },

    uploadMobileBanner: function(image) {
      let refs = this.$refs;
      var self = this;
      var _URL = window.URL || window.webkitURL;
      var file, img;
      if ((file = image.files[0])) {
        img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = async function() {
          // if (img.height != 500 || img.width != 400) {
          //   // if (false) {
          //   self.$refs["fileinput"].reset();
          //   self.showMessageSnackbar("Please upload a 400x500 image");
          // } else {
          var formdata = new FormData();
          formdata.append("assets/images/movies/banners", image.files[0]);
          UploadService.uploadFiles(formdata)
            .then(response => {
              response.data.Message
                ? self.showMessageSnackbar(response.data.Message)
                : "";

              if (response.data.Status) {
                self.staticBanner.appbanner = response.data.Path;
                self.BaseURL = response.data.BaseURL;
              }
            })
            .catch(error => {
              console.log("Catch on AddStaticImages-onUpload Error: ", error);
              self.showMessageSnackbar(
                "Oops! Something went wrong. kindly contact your administrator"
              );
            });
          //  }
        };
      }
    },

    // uploadBanner: function(image) {
    //   let refs = this.$refs;
    //   var _URL = window.URL || window.webkitURL;
    //   var self = this;
    //   var file, img;
    //   if ((file = image.files[0])) {
    //     console.log("Here", image);
    //     // img = new Image();
    //     // img.onload = function() {
    //     // if (img.height != 350 || img.width != 1250) {
    //     if (false) {
    //       // refs.fileinput.reset();
    //       self.$refs["fileinput"].reset();
    //       self.showMessageSnackbar("Please upload a 1250x350 image");
    //     } else {
    //       var formdata = new FormData();
    //       var file = image.files[0];

    //       formdata.append("assets/images/movies/banners", image.files[0]);
    //       UploadService.uploadFiles(formdata)
    //         .then(response => {
    //           if (response.data.Status) {
    //             self.staticBanner.Image = response.data.Path;
    //             self.BaseURL = response.data.BaseURL;
    //             // var previewDiv = document.getElementById("preview");
    //             // var previewImg = "";
    //             // var previewImg = document.createElement("img");
    //             // while (previewDiv.firstChild) {
    //             //   previewDiv.removeChild(previewDiv.firstChild);
    //             // }
    //             // previewDiv.appendChild(previewImg);
    //             // previewImg.src = window.URL.createObjectURL(image.files[0]);
    //             // previewImg.classList.add("img-fluid");
    //           } else {
    //             self.showMessageSnackbar(response.data.Message);
    //           }
    //         })
    //         .catch(error => {
    //           console.log("Catch on AddStaticImages-onUpload Error: ", error);
    //           self.showMessageSnackbar(
    //             "Oops! Something went wrong. kindly contact your administrator"
    //           );
    //         });
    //     }
    //     // };
    //     // img.src = _URL.createObjectURL(file);
    //   }
    // },
    resetStaticBanner: function() {
      if (this.staticBanner.BannerID) {
        window.location.replace(
          window.location.origin + "/" + window.location.hash.split("?")[0]
        );
      }
      this.staticBanner = {
        appthumbimage: "",
        selectedMovieBanner: [],
        desktopbanner: "",
        LanguageID: [],
        appbanner: "",
        youtube: "",
        BannerIsActive: true,
        Flag: 1
      };
      this.BaseURL = "";
      this.$refs["fileinput"].reset();

      // var myNode = document.getElementById("preview");
      // myNode.innerHTML = "";
    },
    // Show Confirmmation Dialog
    handleModalOkay: function(evt) {
      // evt.preventDefault();
      this.modalObject.count = 1;
      this.submitFinalData();
    },
    showSubmitConfirmation: function(payload) {
      this.modalObject.title = payload.title; // "Confirmation";
      this.modalObject.message = payload.message; // "Please re-check the data before submit";
      this.openModal("ModalConfirmationOnSubmit");
    },
    openModal: function(ref) {
      this.$refs[ref].show();
    },
    closeModal: function(ref) {
      this.$refs[ref].hide();
      this.modalObject.title = ""; // "Confirmation";
      this.modalObject.message = ""; // "Please re-check the data before submit";
    },
    // Show Confirmmation Dialog End
    // Show Error Message
    showMessageSnackbar: function(Message) {
      let x = document.getElementById("snackbar");
      x.className = "show";
      x.innerHTML = Message;
      setTimeout(function() {
        x.className = x.className.replace("show", "");
      }, 3000);
    },
    uploadBanner: function(image) {
      let currImagesArr = this.getSafe(
        () => this.pagesList.banner.split(","),
        []
      );
      console.log(image.files);
      let refs = this.$refs;
      var self = this;
      var _URL = this.BASE_URL;
      var file, img;
      if ((file = image.files[0])) {
        img = new Image();
        // img.src = `${_URL}/${file.name}`;
        console.log("img_src", img.src);
        let img_data = "";
        var files = image.files;

        // for (var x = 0; x < files.length; x++) {
        //     this.bannerImg.push(`/uploads/${files[x].name}`);
        // }
        // this.bannerImg = img_data;
        const formData = new FormData();
        for (const i of Object.keys(files)) {
          console.log("imagesformdata", `${_URL}/uploads/${files[i].name}`);
          formData.append("image_arr", files[i]);
        }
        ExhibitorService.MultipleImages(formData)
          .then(response => {
            console.log(response);
            const { data } = response;
            this.bannerImg = [...currImagesArr, ...data.path];
            this.pagesList.banner = this.bannerImg.toString();

            console.log(this.pagesList.banner, "bannerImg");
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    uploadImageHandler: function(image, name, size, index) {
      let currImagesArr = this.getSafe(
        () => this.pagesList.otherData[index][name].split(","),
        []
      );
      console.log(image.files);
      let refs = this.$refs;
      var self = this;
      var _URL = this.BASE_URL;
      var file, img;
      if ((file = image.files[0])) {
        img = new Image();
        // img.src = `${_URL}/${file.name}`;
        console.log("img_src", img.src);
        let img_data = "";
        var files = image.files;

        // for (var x = 0; x < files.length; x++) {
        //     this.bannerImg.push(`/uploads/${files[x].name}`);
        // }
        // this.bannerImg = img_data;
        const formData = new FormData();
        for (const i of Object.keys(files)) {
          console.log("imagesformdata", `${_URL}/uploads/${files[i].name}`);
          formData.append("image_arr", files[i]);
        }
        ExhibitorService.MultipleImages(formData)
          .then(response => {
            console.log(response);
            const { data } = response;
            this.bannerImg = [...currImagesArr, ...data.path];
            this.pagesList.otherData[index][name] = this.bannerImg.toString();

            console.log(this.pagesList.otherData[index][name], "bannerImg");
          })
          .catch(error => {
            console.log(error);
          });
      }
      // let self = this;
      // // if (image.files) {

      // // }
      // var _URL = this.BASE_URL;

      // if (image.files[0]) {
      //   // if (img.height != size.h || img.width != size.w) {
      //   //   // if (false) {
      //   //   self.$refs[name + "fileinput"].reset();
      //   //   self.showMessageSnackbar(`Please upload a ${size.h}x${size.w} image`);
      //   // } else {
      //   var formdata = new FormData();
      //   var files = image.files;
      //   let newFiles = [];
      //   console.log(files.length);

      //   for (var x = 0; x < files.length; x++) {
      //     this.pagesList.otherData[index][name] += `/uploads/${files[x].name},`;
      //   }
      //   console.log(this.pagesList, "pagesListData");

      //   // for (var x = 0; x < files.length; x++) {
      //   //   formdata.append("files[]", files[x]);
      //   // }

      //   // UploadService.uploadFiles(formdata)
      //   //   .then(response => {
      //   //     const { data } = response;
      //   //     data.Message ? self.showMessageSnackbar(data.Message) : "";
      //   //     if (data && data.Status) {
      //   //       console.log(data.Path, "Bannerrrrrrrr");
      //   //       if (name == "coverimage") {
      //   //         self.staticBanner.otherdata[index][name] =
      //   //           self.staticBanner.otherdata[index][name] != ""
      //   //             ? self.staticBanner.otherdata[index][name] + "," + data.Path
      //   //             : data.Path;
      //   //       } else {
      //   //         self.staticBanner.otherdata[index][name] =
      //   //           self.staticBanner.otherdata[index][name] != ""
      //   //             ? self.staticBanner.otherdata[index][name] + "," + data.Path
      //   //             : data.Path;
      //   //       }

      //   //       self.BaseURL = data.BaseURL;
      //   //       this.showMessageSnackbar(data.Message);
      //   //     } else {
      //   //       this.showMessageSnackbar(data.Message);
      //   //     }
      //   //   })
      //   //   .catch(error => {
      //   //     self.showMessageSnackbar(
      //   //       "Oops! Something went wrong. kindly contact your administrator"
      //   //     );
      //   //   });
      //   // }
      // }
    },
    getListOfPages() {
      let loader = this.$loading.show();

      if (this.$route.query.mpm_id) {
        let payload = `?mpm_id=${this.$route.query.mpm_id}`;
        ExhibitorService.GetListOfPages(payload)
          .then(response => {
            const { data } = response;
            this.pagesList = data.Records;
            this.pagesList.banner = this.pagesList.banner.length
              ? this.pagesList.banner.replace(/([^:]\/)\/+/g, "$1")
              : this.pagesList.banner;
            let selectedLangId = data.Records.lang_id;
            console.log("dataLang", data.Records.lang_id);
            let selectedLang = this.LanguageArray.filter(l => {
              return l.lang_id == selectedLangId;
            });

            if (selectedLang.length) {
              this.selectedLang = selectedLang;
            }

            console.log("dataRecords", this.LanguageArray);
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      } else {
        ExhibitorService.GetListOfPages()
          .then(response => {
            const { data } = response;
            this.getAllPagesList = data.Records;
            console.log("getlist", this.getAllPagesList);
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      }
    },
    submitFinalData() {
      let loader = this.$loading.show();

      let testArr = [];
      // this.pagesList.forEach(pages => {
      if (this.pagesList.banner && this.pagesList.banner.length) {
        let temp = [];
        this.pagesList.banner
          .split(",")
          .map(x => x.trim())
          .filter(Boolean)
          .forEach(i =>
            i.startsWith("http") ? temp.push(new URL(i).pathname) : temp.push(i)
          );
        this.pagesList.banner = temp.join(",");
      }
      // });
      // validdate selected lang
      if (this.selectedLang != null) {
        this.pagesList.lang_id = this.selectedLang.lang_id;
      }
      testArr.push(this.pagesList);
      let payload = {
        pagesList: testArr
      };
      ExhibitorService.AddListOfPages(payload)
        .then(response => {
          const { data } = response;
          this.$toasted.show(data.message);
          this.$router.go(-1);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    }
  },
  updated() {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/listOfPages.vue